import { UploadType } from 'src/app/private/shared/enums/upload-type.enum';

export const evidenceModalTypes: { [key: string]: string }[] = [
  { value: UploadType.VIDEO, label: 'Video' },
  { value: UploadType.EVIDENCE, label: 'File' },
];
